import ConfirmationDialog from "components/common/ConfirmationDialog";

interface Props {
  content: string;
  onClose: () => void;
  handleConfirm: ()=> void
}

export default function DeleteConfirmationDialog(props: Props) {
  const { content, handleConfirm, onClose } = props;

  return (
    <>
      <ConfirmationDialog
        title="Confirm delete"
        onConfirm={handleConfirm}
        onCancel={onClose}
        content={content}
      />
    </>
  );
}